import * as types from './types';
import axios from '../axios-orders';

export const fetchPaymentReceiptStart = () => {
  return {
    type: types.FETCH_PAYMENT_HISTORY_START
  }
}

export const fetchPaymentReceiptSuccess = (paymentReceipts, current_page, per_page, total, from) => {
  return {
    type: types.FETCH_PAYMENT_HISTORY_SUCCESS,
    paymentReceipts: {
      paymentReceipts,
      current_page,
      per_page,
      total,
      from,
    }
  }
}

export const fetchPaymentReceiptFail = (error) => {
  return {
    type: types.FETCH_PAYMENT_HISTORY_FAIL,
    error: error
  }
}

export const fetchPaymentReceipt = (page, token, formSearch) => {
  let param = '&status='+formSearch.status+'&date='+formSearch.date;

  return dispatch => {
    dispatch(fetchPaymentReceiptStart())
    axios.get('user/payment_receipt/search_by_branch?page=' + page + param, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        const fetchedPaymentReceipts = []
        for (const key in res.data.data) {
          fetchedPaymentReceipts.push({
            ...res.data.data[key]
          })
        }
        dispatch(fetchPaymentReceiptSuccess(fetchedPaymentReceipts, res.data.current_page, res.data.per_page, res.data.total, res.data.from))
      })
      .catch(err => {
        dispatch(fetchPaymentReceiptFail(err))
      })
  }
}

export const showPaymentReceiptStart = () => {
  return {
    type: types.SHOW_PAYMENT_HISTORY_START
  }
}

export const showPaymentReceiptSuccess = (paymentReceipt) => {
  return {
    type: types.SHOW_PAYMENT_HISTORY_SUCCESS,
    paymentReceipt: paymentReceipt
  }
}

export const showPaymentReceiptFail = (error) => {
  return {
    type: types.SHOW_PAYMENT_HISTORY_FAIL,
    error: error
  }
}

export const showPaymentReceipt = (id, token) => {
  return dispatch => {
    dispatch(showPaymentReceiptStart());
    axios.get('user/payment_receipt/' + id, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        // console.log()
        dispatch(showPaymentReceiptSuccess(res.data))
      })
      .catch(err => {
        dispatch(showPaymentReceiptFail(err))
      })
  }
}